// extracted by mini-css-extract-plugin
export default {"input":"_10Hm_","wrapper":"LZRyY","radio":"BkQXm","label":"_86rmj"};